<ng-template #customContent>
  <span *ngIf="!reviewMode" class="sm:hidden text-primary underline hover:cursor-pointer" (click)="showVideo()">Not sure where to start? Watch a quick video!</span>
  <div *ngIf="!reviewMode" class="sm:hidden flex flex-row items-center max-sm:mt-4 justify-center sm:justify-end gap-4">
    <tandem-button theme="solid" [onClick]="onCreateNew.bind(this)">Create New</tandem-button>
    <tandem-button theme="outline" [onClick]="onCreateNew.bind(this, true)">Duplicate Most Recent</tandem-button>
  </div>
</ng-template>

<div class="w-full flex-col gap-8 py-10 md:py-20">
  <div class="w-full flex items-start gap-10 lg:gap-20">
    <tandem-card class="max-sm:hidden mt-40 lg:w-1/5">
      <div class="space-y-4">
        <h3 class="text-lg">Find {{getTrackingToolName('single')}}</h3>
        <div [formGroup]="findStatementForm" class="flex flex-col">
          <tandem-form-input
            [form]="findStatementForm"
            [controlName]="'startDate'"
            [inputType]="'date'"
            [inputId]="'startDate'"
            [label]="'Start Date'"
            [placeholder]="'Start Date'"></tandem-form-input>
          <tandem-form-input
            [form]="findStatementForm"
            [controlName]="'endDate'"
            [inputType]="'date'"
            [inputId]="'endDate'"
            [label]="'End Date'"
            [placeholder]="'End Date'"></tandem-form-input>
          <tandem-button color="white" [onClick]="resetForm.bind(this)">Reset</tandem-button>
        </div>
      </div>
    </tandem-card>
    <div class="flex flex-col gap-8 w-full items-center">
      <div class="max-sm:hidden flex flex-col sm:flex-row justify-between w-full">
        <div class="flex flex-col gap-4">
          <h1 class="text-4xl">{{getTrackingToolName('plural')}}</h1>
          <span *ngIf="!reviewMode" class="text-primary underline hover:cursor-pointer" (click)="showVideo()">Not sure where to start? Watch a quick video!</span>
        </div>
        <div *ngIf="!reviewMode" class="flex flex-row items-center max-sm:mt-4 justify-center sm:justify-end gap-4">
          <tandem-button theme="solid" [onClick]="onCreateNew.bind(this)">Create New</tandem-button>
          <tandem-button theme="outline" [onClick]="onCreateNew.bind(this, true)">Duplicate Most Recent</tandem-button>
        </div>
      </div>
      <div class="w-full">
        <tandem-table class="w-full" [tableConfiguration]="tableConfig" [data]="data"></tandem-table>
      </div>
      <tandem-card class="w-full">
        <div class="w-full flex flex-col gap-10">
          <div class="flex flex-row justify-start gap-5">
            <h3 class="text-2xl">Cash Flow Over Time{{usingSampleData ? ' (Sample Data)' : ''}}</h3><tandem-tooltip *ngIf="usingSampleData" [text]="'You must have at least two ' + getTrackingToolName('plural') + ' before we can start tracking your financial history.'"></tandem-tooltip>
          </div>
          <div echarts [options]="chartOptions" class="w-full max-w-full h-400" id="cashFlowTrends"></div>
        </div>
      </tandem-card>
    </div>
  </div>
</div>
